import Web3 from "web3";
import JSBI from "jsbi";

import { ICOTokenContract } from "../Config/Contract/Contract";
import { USDTToken } from "../Config/Contract/Contract";
import { USDTTokenABI } from "../Config/ABI/USDTToken";
import { RanpoToken } from "../Config/Contract/Contract";
import { RanpoTokenABI } from "../Config/ABI/PayoutTokenABI";

import { ICO_ABI } from "../Config/ABI/ICO_ABI";

const getContract = (contractAddress, ABI, provider) => {
  const web3_ = new Web3(provider);
  return new web3_.eth.Contract(ABI, contractAddress);
};

const MaxUint256 = JSBI.BigInt(
  "0xffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffff"
);

export const GetApproveStatus = (provider) => {
  return getContract(USDTToken, USDTTokenABI, provider).methods.approve(
    ICOTokenContract,
    "11579208923731619542357098500868790785326998466564056403945758400791312963993"
    // "1000000000000000000000000000"
    // Web3.utils.toWei(1000000000000000000000000000000)
  );
};

export const GetAllowance = (provider, address) => {
  return getContract(USDTToken, USDTTokenABI, provider)
    .methods.allowance(address, ICOTokenContract)
    .call();
};

export const GetICOtoken = (provider, address) => {
  return getContract(ICOTokenContract, ICO_ABI, provider)
    .methods.contractMROToken()
    .call();
};

// balanceOf

export const GetUserToken = (provider, address) => {
  return getContract(USDTToken, USDTTokenABI, provider)
    .methods.balanceOf(address)
    .call();
};

// owner
export const Getowneraddres = (provider, address) => {
  return getContract(ICOTokenContract, ICO_ABI, provider)
    .methods.owner()
    .call();
};

export const GetUserPresale = (provider, address) => {
  return getContract(ICOTokenContract, ICO_ABI, provider)
    .methods.preSale()
    .call();
};

// saleDetails
export const Salestatus = (provider) => {
  return getContract(ICOTokenContract, ICO_ABI, provider)
    .methods.saleDetails()
    .call();
};
// close saledetails

export const GetICOStatus = (provider) => {
  return getContract(ICOTokenContract, ICO_ABI, provider)
    .methods.isICOOver()
    .call();
};

export const GetHardCapStatus = (provider) => {
  return getContract(ICOTokenContract, ICO_ABI, provider)
    .methods.isHardCapReach()
    .call();
};

export const TokenBalance = (provider) => {
  console.log(provider);
  return getContract(USDTToken, USDTTokenABI, provider)
    .methods.balanceOf(ICOTokenContract)
    .call();
};

// approve
export const getWalletBalance = (provider, account) => {
  const web3_ = new Web3(provider);
  return new web3_.eth.getBalance(account);
};
